<!-- 学习班 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <el-form ref="form" :model="form" label-width="200px" style="width:800px;" label-position="left">
          <el-form-item label="学习班类型名">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="是否属于下属单位上传使用">
            <el-radio-group v-model="form.isBelongSub">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="publish" :loading="loading">立即创建</el-button>
            <!-- <el-button>取消</el-button> -->
          </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>


<script>
import { BaseVue } from "@/mixin/index";
import { editAddApi } from "@/api/module/studyclasstype/studyclasstype";

export default {
  name: "StudyClassTypeAdd",
  
  mixins: [BaseVue],
  
  data() {
    return {
      form: {
        title: '',
        isBelongSub: 0
      },
      loading: false,
      status: ""
    };
  },
  
  methods: {
    publish() {
      this.loading = true;
      this.status = "0";
      this.addDemo();
    },
    
    temporaty() {
      this.loading = true;
      this.status = "1";
      this.addDemo();
    },
    
    addDemo() {
      if (!this.form.title) {
        this.$message.error("学习班名称不能为空！");
        this.loading = false;
        return false;
      }
      
      const data = {
        "title": this.form.title,
        "status": this.status,
        "isBelongSub": this.form.isBelongSub
      };
      
      editAddApi(data)
        .then(response => {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          setTimeout(() => {
            this.$router.replace({
              path: '/standard/studyclasstype/dashboard'
            });
          }, 1500);
        }).finally(() => {
          this.loading = false;
        });
    }
  },
  
  mounted() {
    // 挂载后的逻辑
  }
};
</script>

<style scoped>
</style>

